export default "__VITE_ASSET__C9SFjSI1__"